"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = require("luxon");
var AuthUserInfo = /** @class */ (function () {
    function AuthUserInfo(accessToken, decodedAccessToken, permissions) {
        this.accessToken = accessToken;
        this.decodedAccessToken = decodedAccessToken;
        this.permissions = permissions;
        this.expiresAt = luxon_1.DateTime.fromSeconds(decodedAccessToken.exp);
    }
    AuthUserInfo.prototype.isExpired = function () {
        return this.expiresAt < luxon_1.DateTime.now();
    };
    return AuthUserInfo;
}());
exports.default = AuthUserInfo;
//# sourceMappingURL=AuthUserInfo.js.map